<template>
  <div class="section-contact" id="section-contact">
    <div-container full="true">

      <div class="columns is-gapless is-centered is-multiline" v-if="false">
        <div class="column is-6 has-text-centered">
          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <a href="https://www.facebook.com/bosshogcookoff" target="_blank">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com/bosshogcookoff" target="_blank">
              <i class="fa fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/bosshogcookoff" target="_blank">
              <i class="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="columns is-gapless is-centered is-multiline" style="margin-bottom:1em;">
        <div class="column is-12 has-text-left">
          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <h3 class="title" style="font-size:1.8em;">Contact</h3>
          </div>
        </div>
      </div>

      <div class="columns is-gapless is-multiline">
        <div class="column is-12">
          <div class="cont-form cont-form-info" data-aos="fade-up" data-aos-once="true">
            <b-field>
              <b-input value="" placeholder="Name" v-model.trim="name" @input="$v.name.$touch()"></b-input>
            </b-field>
            <b-field>
              <b-input value="" placeholder="Email Address" v-model.trim="email" @input="$v.email.$touch()"></b-input>
            </b-field>
          </div>
        </div>

        <div class="column is-12">
          <div class="cont-form cont-form-message" data-aos="fade-up" data-aos-once="true">
            <b-field>
              <b-input maxlength="500" type="textarea" placeholder="Message" v-model.trim="message" @input="$v.message.$touch()"></b-input>
            </b-field>

            <b-field style="width:100%;">
              <div class="columns is-gapless is-flex-mobile is-vcentered">
                <!-- <div class="column is-narrow">
                  <img class="captcha-image img-responsive" :src="captchaImage" />
                </div>
                <div class="column column-captcha-wrapper">
                  <b-input name="captcha" placeholder="Captcha" v-model.trim="captcha" @input="$v.captcha.$touch()" type="text" style="width:100%;" />
                </div> -->
                <div class="column captcha-image-wrapper">
                  <vue-recaptcha :sitekey="recaptchaKey" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" @render="onRenderRecaptcha"></vue-recaptcha>
                  <input type="hidden" v-model.trim="recaptcha" />
                  <p v-if="recaptcha && recaptcha.$dirty && recaptcha.$invalid && recaptcha.$params.required && !recaptcha.required" class="help is-danger">Invalid recaptcha.</p>
                </div>
                <div class="column is-4 is-3-mobile" v-if="isDesktop">
                  <button class="button is-outlined" :class="{ 'is-loading': loading }" @click="onSend($v)">
                    <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
                  </button>
                </div>
              </div>
            </b-field>

            <!-- <b-field style="width:100%;margin-bottom:0;">
              <div class="columns is-gapless is-flex-mobile is-vcentered">
                <div class="column captcha-image-wrapper">
                  <vue-recaptcha :sitekey="recaptchaKey" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha" @render="onRenderRecaptcha"></vue-recaptcha>
                  <input type="hidden" v-model.trim="recaptcha" />
                  <p v-if="recaptcha && recaptcha.$dirty && recaptcha.$invalid && recaptcha.$params.required && !recaptcha.required" class="help is-danger">Invalid recaptcha.</p>
                </div>
              </div>
            </b-field> -->

            <b-field style="width:100%;" v-if="!isDesktop">
              <!-- this must tally with duplicated control -->
              <button class="button is-outlined" :class="{ 'is-loading': loading }" @click="onSend($v)">
                <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
              </button>
            </b-field>

            <p v-if="feedback">{{ feedback }}</p>
          </div>
        </div>
      </div>

    </div-container>
  </div>
</template>

<script type="text/javascript">
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Site from '@/apis/Site'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'contactsection',
  mixins: [validationMixin],
  components: {
    DivContainer,
    DivColumns,
    VueRecaptcha
  },
  data: function () {
    return {
      isDesktop: true,
      name: '',
      email: '',
      message: '',
      // captcha: '',
      // session: '',
      // captchaImage: undefined,
      recaptcha: undefined,
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      feedback: false,
      loading: false,
      navEmail: EventBus._data._navEmail
    }
  },
  mounted: function () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })
  },
  methods: {
    // onRecaptcha: function (onRecaptchaSuccess) {
    //   Site.getRecaptcha()
    //   .then(data => {
    //     // console.log('get recaptcha')
    //     // console.log(data)
    //     if (onRecaptchaSuccess) {
    //       onRecaptchaSuccess(data)
    //     }
    //   })
    //   .catch(error => {
    //     console.log('get recaptcha error')
    //     console.log(error)
    //   })
    // },
    onRenderRecaptcha: function (id) {
      this.recaptcha = undefined
    },
    onExpiredRecaptcha: function () {
      this.recaptcha = undefined
    },
    onVerifyRecaptcha: function (response) {
      if (response && response.length > 0) {
        this.recaptcha = response
      }
    },
    onResetRecaptcha: function () {
      this.$refs.recaptcha.reset()
      this.recaptcha = undefined
    },
    onSend: function ($v) {
      var _self = this
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false
        _self.loading = true
        Site.email(
          _self.recaptcha,
          _self.name,
          _self.email,
          _self.message,
          // _self.captcha,
          // _self.session,
        )
        .then(data => {
          _self.loading = false

          // invalid captcha
          if (data && data.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.'
            return
          }

          // invalid captcha
          if (data && data.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please re-type again.'
            return
          }

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
            return
          }

          _self.name = ''
          _self.email = ''
          _self.message = ''
          // _self.captcha = ''
          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Thank you for reaching out to The Boss. Someone will get back to you shortly.'
        })
        .catch(error => {
          console.log('invalid email', error)
          // this.error = error.error
          console.log(error)
          // _self.captcha = ''

          // invalid captcha
          if (error && error.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.'
            _self.loading = false
            return
          }

          // invalid captcha
          if (error && error.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please retype again.'
            _self.loading = false
            return
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
          _self.loading = false
        })
      }
    }
  },
  validations: {
    email: {
      required,
      email
    },
    name: {
      required
    },
    message: {
      required
    },
    recaptcha: {
      required
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.section-contact {
  // padding: 1rem 0;
  margin-top: 5em;
  margin-bottom: 1em;
  padding: 0 0.75rem;

  @media screen and (min-width: $desktop) {
    padding: 0 0.75rem;
  }

  & .cont-desc {
    // margin-top: 1.2rem;
    padding: 0;

    .fa {
      font-size: 2.5em;
      padding: 5px 15px;
      color: #aaaaaa;

      @media screen and (min-width: $tablet) {
        padding: 5px 5px;
      }

      // @media screen and (min-width: $desktop) {
      //   padding: 5px 5px;
      // }

      @media screen and (min-width: $fullhd) {
        padding: 5px 15px;
      }
    }

    .title {
      font-family: $font-family-title;
      text-transform: uppercase;
    }

    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }

  .cont-form {
    margin-top: 1rem;
    // padding: 0rem 0.75rem;

    @media screen and (min-width: $desktop) {
      padding: 0;
    }
    .field {
    }

    .control {
      margin-top: 0;
      margin-bottom: 0;
    }

    &>p {
      // for feedback field only
      margin-top: 1rem;
      color: $color-gray-mid;
      text-align: center;
      font-weight: bold;
      @media screen and (min-width: $desktop) {
        text-align: left;
      }
    }

    span {
      display: block;
    }

    .captcha-image {
      height: 3.6em;
      margin-top: 5px;
      margin-bottom: 0px;
      margin-right: 0px;
      @media screen and (min-width: $tablet) {
        margin-right: 15px;
      }
    }

    .column-captcha-wrapper {
      padding-right: 0px;
      @media screen and (min-width: $tablet) {
        padding-right: 15px;
      }
    }

    input, textarea {
      // border: 0;
      font-size: 0.8em;
      box-shadow: none;
      background: white;
      border-bottom: 1px solid #bbbbbb;

      height: 3em;
      padding-left: 15px;
      padding-right: 15px;

      &[name='captcha'] {
        padding-left: 5px;
        padding-right: 5px;
        @media screen and (min-width: $desktop) {
          padding-left: 15px;
          padding-right: 15px;
        }
      }

      &::placeholder {
        color: #999999;
      }
      &:focus, &.is-focused, &:active, &.is-active {
        border-color: $color-black;
      }
    }

    textarea {
      height: auto;
      @media screen and (min-width: $tablet) {
        height: 175px;
      }
    }

    button {
      border-radius: 0;
      // border: 2px solid $color-gray-mid;
      font-size: 0.8em;
      font-weight: bold;
      background-color: $color-orange;
      width: 100%;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      opacity: 1;
      flex-direction: column;

      & p {
        color: $color-black;
      }

      &:after {
        border-color: $color-gray-mid;
        border-right-color: transparent;
        border-top-color: transparent;
      }

      @media screen and (min-width: $desktop) {
        // width: 150px;
        // height: auto;
        // padding-top: 12px;
        // padding-bottom: 12px;
      }

      &:hover {
        background-color: $color-gray;
        -webkit-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
        & p {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ContactSection.vue?4d6a165e